/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
   <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">返回首页</el-breadcrumb-item>

    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <!-- <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入物料名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入物料代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form> -->
    <!--列表-->
	<template>
		<!-- <el-card class="box-card" shadow="never"  style="width: 100%;">
		  <div slot="header" class="clearfix">
		    <span>卡片名称</span>
		  </div>
		  <div v-for="o in 4" :key="o" class="text item" style="width: 20%;">
		    {{'列表内容 ' + o }}
		  </div>
		</el-card> -->
		<div v-for="domain in dynamicValidateForm">
		 <div style="font-size:20px;font-weight:bold;margin-top: 50px;width: 100%;">{{domain.LName}}
	     </div>
		    <el-divider style="margin-top: 0px;margin-bottom: 0px;"></el-divider>
			<div>
			  <div v-for="ke in domain.PLName" style="width: 23%;display: inline-block; margin-top: 10px;" class="hovetycolor" @click="ahrouter(domain.PLName,ke)">{{ke.LName}}</div>
			 </div>
		</div>
	</template>
    <!-- <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="deptName" label="物料名称" width="300">
      </el-table-column>
      <el-table-column sortable prop="deptNo" label="物料代码" width="300">
      </el-table-column>
      <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
  <!--  <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="物料名称" prop="deptName">
          <el-input size="small" v-model="editForm.deptName" auto-complete="off" placeholder="请输入物料名称"></el-input>
        </el-form-item>
        <el-form-item label="物料代码" prop="deptNo">
          <el-input size="small" v-model="editForm.deptNo" auto-complete="off" placeholder="请输入物料代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>  -->
  </div>

</template>

<script>
import { deptList, deptSave, deptDelete,getMenuApp,LIClass } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import axios from 'axios';


export default {
  data() {
    return {
      menuID:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入物料代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
	  dynamicValidateForm:[],
      // 删除物料
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
	   user: {},
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
	  let ID="";
 if(this.$route.query.LItemID!==undefined){
	 if(typeof(this.$route.query.LItemID.LItemID)=="string"){
		 this.menuID =this.$route.query.LItemID.LItemID
	 }else{
		 this.menuID =JSON.parse(this.$route.query.LItemID).LItemID
	 }
	  console.log(typeof(this.$route.query.LItemID.LItemID),this.$route.query) 
    }else{
      this.menuID=""
    }
	  this.user = JSON.parse(localStorage.getItem('userdata'))
	
  this.getmenu()


  },
  watch:{
  		"$route"(to,from){
        console.log(to,from)
           let ID=JSON.parse(to.query.LItemID).LItemID
           let ID1=JSON.parse(from.query.LItemID).LItemID
           this.menuID=ID
        if(ID!=ID1)
        this.dynamicValidateForm=[]
        this.getmenu();
          }
      },


  /**
   * 里面的方法只有被调用才会执行..
   */
  methods: {
getmenu(){
  	 
	let phems = {
	v_str_AccountID: '165',
	UserName:this.user[0].UserName ,//取admin名
  ShowType: '0',
  LType:''
	}
  let raw = []
		getMenuApp(phems).then(res => {
      console.log(res.Data)
      for(let e=0;e<res.Data.length;e++){
      raw = res.Data[e].menus
			for(let i=0;i<raw.length;i++){//一级菜单个数
				 if( this.menuID!=''||ID!=undefined){//ID为空值
					 if( this.menuID==raw[i].LItemID){//路由ID等于一级菜单中的LItemClassID
						 this.dynamicValidateForm.push({LName:raw[i].LName,PLName:raw[i].menus})
					 }
				 }else{//一级菜单下所有内容进行横版排列
					   this.dynamicValidateForm.push({LName:raw[i].LName,PLName:raw[i].menus})
				 }
			}
      }
		
		})

},
	ahrouter(PLName,kLName){
		console.log(kLName.FURL)
		//this.$router.replace( kLName.FURL)
		this.$router.push({
			path: kLName.FURL,
			query: {
				LItemID: kLName
			}
		})

	},


    // 获取公司列表
    getdata(parameter) {
      
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {		
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}

</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
 .el-card__body{
    padding: 0px 0px 10px 10px;
  }
  .el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      margin: 10px 0;
  }
  div.hovetycolor:hover{
	  color: dodgerblue;

  }
</style>



// WEBPACK FOOTER //
// src/views/goods/Edata.vue